<a href="https://www.rooms.chat/" target="_blank">
  <button class="promo {{ colorMode() }}" [class.revealed]="revealed()">
    <span>{{ 'Get Started with Rooms' | translate }}</span>
    <img src="assets/icon_{{ inverseColorMode() }}.svg" />
  </button>
</a>
